import React, { FC } from 'react';
import styles from '../login/styles/password-reset-required.scss';
import { Button } from 'shamrock-clover-ui';
import { getDeviceType } from '../../utils/utils';
import { useTranslation } from 'react-i18next';
import { LoginForms } from '../login/Login';
import { RootState } from 'bootstrap';
import { useSelector } from 'react-redux';
const Config = require('Config');

type PasswordResetRequiredProps = { setCurrentForm: (value: LoginForms) => void; handleClearState: () => void; };
export const PasswordResetRequired: FC<PasswordResetRequiredProps> = ({ setCurrentForm, handleClearState }) => {
  const { t } = useTranslation();
  const features = useSelector<RootState, string[]>((state) => state.app.features);
  const isUniversalLinkEnabled = features.includes('cb07431ef6713159ea018cfe46575df241f90dfc017c7a6b458f7cfb8b8834d0');

  const backToLogin = () => {
    if (getDeviceType() === 'Desktop') {
      handleClearState();
      setCurrentForm(LoginForms.VERIFICATION_REQUEST);
    } else {
      window.location.href = isUniversalLinkEnabled ? Config.backToLoginBranchUrl : 'rtspro://back_to_login';
    }
  };

  return (
    <div className={styles.contentBox}>
      <div className={styles.title}>
        <h2>{t('authentication.password_update_required')}</h2>
        <p>
          {t(
            'authentication.we_noticed_some_unusual_activity_on_your_account_as_a_precautionary_measure_weve_temporarily_logged_you_out_please_update_your_password_to_ensure_the_security_of_your_account',
          )}
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <div className={styles.button}>
          <Button buttonStyle={'outlined'} type="button" onClick={backToLogin} width='164' height='44'>
            {t('back_to_login')}
          </Button>
        </div>
        <div className={styles.button}>
          <Button
            onClick={() => setCurrentForm(LoginForms.PASSWORD_RESET_FORM)}
            buttonStyle="solid"
            type="button"
            width='186'
            height='44'
          >
            {t('continue')}
          </Button>
        </div>
      </div>
    </div>
  );
};
